"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.previousPeriodRecommendationEnabled = exports.percentRecommendationEnabled = exports.comparisonAndTrendingRecommendationEnabled = exports.overTimeComparisonRecommendationEnabled = exports.isComparisonOverTimeAllowed = exports.isShowInPercentAllowed = exports.hasNonAllTimeFilter = exports.noDerivedMeasurePresent = exports.hasOneCategory = exports.hasNoStacksWithDate = exports.hasNoStacks = exports.hasUsedDate = exports.hasUsedDateIgnoreAllTime = exports.hasGlobalDateFilter = exports.hasGlobalDateFilterIgnoreAllTime = exports.hasMoreThanOneMasterMeasure = exports.hasMoreThanOneCategory = exports.hasSomeSegmentByItems = exports.hasNoAttribute = exports.hasNoSecondaryMeasures = exports.hasNoMeasures = exports.filteredByDerivedMeasure = exports.hasOneMasterMeasureInBucket = exports.getMasterMeasuresCount = exports.hasOneMeasure = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var some_1 = tslib_1.__importDefault(require("lodash/some"));
var every_1 = tslib_1.__importDefault(require("lodash/every"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var reduce_1 = tslib_1.__importDefault(require("lodash/reduce"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var bucketHelper_1 = require("./bucketHelper");
var bucket_1 = require("../constants/bucket");
function hasOneMeasure(buckets) {
    return bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.MEASURES) === 1;
}
exports.hasOneMeasure = hasOneMeasure;
function hasOneMasterMeasure(buckets) {
    return getMasterMeasuresCount(buckets, sdk_ui_1.BucketNames.MEASURES) === 1;
}
function getMasterMeasuresCount(buckets, bucketLocalIdentifier) {
    var items = bucketHelper_1.getBucketItems(buckets, bucketLocalIdentifier);
    return reduce_1.default(items, function (acc, item) { return (item.masterLocalIdentifier ? acc : acc + 1); }, 0);
}
exports.getMasterMeasuresCount = getMasterMeasuresCount;
function hasOneMasterMeasureInBucket(buckets, bucketLocalIdentifier) {
    return getMasterMeasuresCount(buckets, bucketLocalIdentifier) === 1;
}
exports.hasOneMasterMeasureInBucket = hasOneMasterMeasureInBucket;
function filteredByDerivedMeasure(buckets, filters) {
    var measures = bucketHelper_1.getAllItemsByType(buckets, [bucket_1.METRIC]);
    var derivedMeasuresLocalIdentifiers = measures.reduce(function (acc, measure) {
        if (measure.masterLocalIdentifier) {
            acc.push(measure.localIdentifier);
        }
        return acc;
    }, []);
    var allBucketFilters = flatMap_1.default(filters.items, function (filterItem) { return filterItem.filters; });
    return allBucketFilters
        .filter(bucketHelper_1.isMeasureValueFilter)
        .some(function (measureValueFilter) {
        return derivedMeasuresLocalIdentifiers.includes(measureValueFilter.measureLocalIdentifier);
    });
}
exports.filteredByDerivedMeasure = filteredByDerivedMeasure;
function hasNoMeasures(buckets) {
    return bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.MEASURES) === 0;
}
exports.hasNoMeasures = hasNoMeasures;
function hasNoSecondaryMeasures(buckets) {
    return bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.SECONDARY_MEASURES) === 0;
}
exports.hasNoSecondaryMeasures = hasNoSecondaryMeasures;
function hasNoAttribute(buckets) {
    return bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.ATTRIBUTE) === 0;
}
exports.hasNoAttribute = hasNoAttribute;
function hasSomeSegmentByItems(buckets) {
    return bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.SEGMENT) !== 0;
}
exports.hasSomeSegmentByItems = hasSomeSegmentByItems;
function hasMoreThanOneCategory(buckets) {
    return bucketHelper_1.getAllAttributeItems(buckets).length > 1;
}
exports.hasMoreThanOneCategory = hasMoreThanOneCategory;
function hasMoreThanOneMasterMeasure(buckets, bucketLocalIdentifier) {
    return getMasterMeasuresCount(buckets, bucketLocalIdentifier) > 1;
}
exports.hasMoreThanOneMasterMeasure = hasMoreThanOneMasterMeasure;
function hasSomeCategories(buckets) {
    return bucketHelper_1.getAttributeItemsWithoutStacks(buckets).length > 0;
}
function hasNoCategories(buckets) {
    return bucketHelper_1.getAttributeItemsWithoutStacks(buckets).length === 0;
}
function allRulesMet(rules, buckets, filters) {
    return rules.every(function (rule) { return rule(buckets, filters); });
}
function hasDateInCategories(buckets) {
    return some_1.default(bucketHelper_1.getAllAttributeItems(buckets), bucketHelper_1.isDateBucketItem);
}
function hasGlobalDateFilterIgnoreAllTime(filters) {
    if (filters) {
        return some_1.default(filters.items, function (item) {
            var _a, _b, _c;
            var interval = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.filters) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.interval) !== null && _c !== void 0 ? _c : null;
            return interval && interval.name !== bucket_1.ALL_TIME;
        });
    }
    return false;
}
exports.hasGlobalDateFilterIgnoreAllTime = hasGlobalDateFilterIgnoreAllTime;
function hasGlobalDateFilter(filters) {
    if (filters) {
        return some_1.default(filters.items, function (item) { var _a, _b; return (_b = (_a = item === null || item === void 0 ? void 0 : item.filters) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.interval; });
    }
    return false;
}
exports.hasGlobalDateFilter = hasGlobalDateFilter;
function hasUsedDateIgnoreAllTime(buckets, filters) {
    return hasDateInCategories(buckets) || hasGlobalDateFilterIgnoreAllTime(filters);
}
exports.hasUsedDateIgnoreAllTime = hasUsedDateIgnoreAllTime;
function hasUsedDate(buckets, filters) {
    return hasDateInCategories(buckets) || hasGlobalDateFilter(filters);
}
exports.hasUsedDate = hasUsedDate;
function hasNoWeekGranularity(buckets) {
    if (hasDateInCategories(buckets)) {
        return every_1.default(bucketHelper_1.getAllAttributeItems(buckets), function (item) { return (item === null || item === void 0 ? void 0 : item.granularity) !== bucket_1.GRANULARITY.week; });
    }
    return every_1.default(bucketHelper_1.getBucketItems(buckets, bucket_1.FILTERS), function (item) { return (item === null || item === void 0 ? void 0 : item.granularity) !== bucket_1.GRANULARITY.week; });
}
function hasNoMeasureDateFilter(buckets) {
    return !some_1.default(bucketHelper_1.getMeasureItems(buckets), function (item) {
        var filters = item === null || item === void 0 ? void 0 : item.filters;
        return filters && some_1.default(filters, bucketHelper_1.isDateBucketItem);
    });
}
function hasNoStacks(buckets) {
    return bucketHelper_1.getStackItems(buckets).length === 0;
}
exports.hasNoStacks = hasNoStacks;
function hasNoStacksWithDate(buckets) {
    return bucketHelper_1.getStackItems(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]).length === 0;
}
exports.hasNoStacksWithDate = hasNoStacksWithDate;
function hasOneCategory(buckets) {
    return bucketHelper_1.getAttributeItemsWithoutStacks(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]).length === 1;
}
exports.hasOneCategory = hasOneCategory;
function isShowPercentageUnselected(buckets) {
    var _a, _b;
    return !((_b = (_a = bucketHelper_1.getBucketItems(buckets, sdk_ui_1.BucketNames.MEASURES)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.showInPercent);
}
function noDerivedMeasurePresent(buckets) {
    var measures = bucketHelper_1.getAllItemsByType(buckets, [bucket_1.METRIC]);
    return !some_1.default(measures, function (measure) { return measure.masterLocalIdentifier; });
}
exports.noDerivedMeasurePresent = noDerivedMeasurePresent;
function hasFirstDate(buckets) {
    var _a;
    var firstAttributeItem = (_a = bucketHelper_1.getAllAttributeItems(buckets)) === null || _a === void 0 ? void 0 : _a[0];
    return firstAttributeItem && bucketHelper_1.isDateBucketItem(firstAttributeItem);
}
function hasNotFirstDate(buckets) {
    return !hasFirstDate(buckets);
}
function hasNonAllTimeFilter(filters) {
    var _a, _b, _c, _d, _e;
    var filterBucketItems = (_a = filters === null || filters === void 0 ? void 0 : filters.items) !== null && _a !== void 0 ? _a : [];
    var dateFilter = filterBucketItems.find(function (filter) {
        return (filter === null || filter === void 0 ? void 0 : filter.attribute) === "attr.datedataset";
    });
    var filterInterval = (_e = (_d = (_c = (_b = dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.filters) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.interval) === null || _d === void 0 ? void 0 : _d.interval) !== null && _e !== void 0 ? _e : [];
    return !isEmpty_1.default(filterInterval);
}
exports.hasNonAllTimeFilter = hasNonAllTimeFilter;
function hasNoRankingFilter(_, filters) {
    var allBucketFilters = flatMap_1.default(filters.items, function (filterItem) { return filterItem.filters; });
    return !allBucketFilters.some(bucketHelper_1.isRankingFilter);
}
function isShowInPercentAllowed(buckets, filters, bucketLocalIdentifier) {
    var rules = [hasNoStacks, hasSomeCategories, hasNoRankingFilter];
    return (allRulesMet(rules, buckets, filters) &&
        hasOneMasterMeasureInBucket(buckets, bucketLocalIdentifier) &&
        !filteredByDerivedMeasure(buckets, filters));
}
exports.isShowInPercentAllowed = isShowInPercentAllowed;
function isComparisonOverTimeAllowed(buckets, filters, weekFiltersEnabled) {
    var rules = weekFiltersEnabled ? [hasNoStacksWithDate] : [hasNoStacksWithDate, hasNoWeekGranularity];
    return allRulesMet(rules, buckets, filters) && hasGlobalDateFilter(filters);
}
exports.isComparisonOverTimeAllowed = isComparisonOverTimeAllowed;
function overTimeComparisonRecommendationEnabled(referencePoint, weekFiltersEnabled) {
    var _a;
    var baseRules = [
        noDerivedMeasurePresent,
        hasOneMeasure,
        hasFirstDate,
        hasNoStacksWithDate,
        hasOneCategory,
        hasNoMeasureDateFilter,
    ];
    var rules = weekFiltersEnabled ? baseRules : tslib_1.__spreadArrays(baseRules, [hasNoWeekGranularity]);
    return (allRulesMet(rules, (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : []) &&
        hasGlobalDateFilterIgnoreAllTime(referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.filters));
}
exports.overTimeComparisonRecommendationEnabled = overTimeComparisonRecommendationEnabled;
function comparisonAndTrendingRecommendationEnabled(buckets) {
    var rules = [hasOneMeasure, noDerivedMeasurePresent, hasNoCategories];
    return allRulesMet(rules, buckets);
}
exports.comparisonAndTrendingRecommendationEnabled = comparisonAndTrendingRecommendationEnabled;
function percentRecommendationEnabled(buckets, filters) {
    var rules = [
        isShowPercentageUnselected,
        hasNotFirstDate,
        hasOneMasterMeasure,
        hasOneCategory,
        hasNoStacks,
        hasNoRankingFilter,
    ];
    return allRulesMet(rules, buckets, filters) && !filteredByDerivedMeasure(buckets, filters);
}
exports.percentRecommendationEnabled = percentRecommendationEnabled;
function previousPeriodRecommendationEnabled(buckets) {
    var rules = [
        hasOneMeasure,
        hasOneCategory,
        hasNotFirstDate,
        hasNoStacks,
        noDerivedMeasurePresent,
        isShowPercentageUnselected,
        hasNoMeasureDateFilter,
    ];
    return allRulesMet(rules, buckets);
}
exports.previousPeriodRecommendationEnabled = previousPeriodRecommendationEnabled;
//# sourceMappingURL=bucketRules.js.map